import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';
import type { IModalContext, IModalState, ModalPropsMap, ModalType } from './modal.types';

const initialModals: IModalState = {
  confirm: null,
};

export const ModalContext = createContext<IModalContext>({
  modals: initialModals,
  openModal: () => {},
  closeModal: () => {},
});

export const useModal = () => useContext(ModalContext);

const ModalProvider = (props: PropsWithChildren) => {
  const [modals, setModals] = useState<IModalState>(initialModals);

  const openModal = <T extends ModalType>(args: { type: T; props: ModalPropsMap[T] }) => {
    setModals((prev) => ({
      ...prev,
      [args.type]: args.props,
    }));
  };

  const closeModal = (type: ModalType) => {
    setModals((prev) => ({
      ...prev,
      [type]: null,
    }));
  };

  return (
    <ModalContext.Provider value={{ modals, openModal, closeModal }}>
      {props.children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
